import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError, retry } from '@reduxjs/toolkit/query';
import { config } from '../../config';
import { getAccessToken, getActiveCompany } from 'src/frontend-common/localstorage';
import { Company } from 'src/frontend-common/dto/Interfaces/ICompany';

export const BASE_URL = `${config.API_PROTOCOL}://${config.API_HOST}${config.API_PORT ? `:${config.API_PORT}` : ''}`;

const prepareHeaders = (headers: Headers) => {
  const token = getAccessToken();
  if (token) {
    headers.set('Authorization', token);
  }
  return headers;
};

const baseQueryRaw = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders,
  mode: 'cors',
});

const baseQueryWithRetry = retry(baseQueryRaw, { maxRetries: 5 });

type FormParams = {
  formData?: boolean;
} & FetchArgs;

const withCompanyId =
  (baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>): BaseQueryFn<string | FormParams, unknown, FetchBaseQueryError> =>
  async (args, api, extraOptions) => {
    const activeCompany: Company | null = process.env.NODE_ENV === 'test' ? { id: 'idTest', name: 'nameTest' } : getActiveCompany();

    if (!activeCompany) {
      return {
        error: {
          status: 400,
          statusText: 'Bad Request',
          data: 'No active company found',
        },
      };
    }

    if (api.type === 'mutation') {
      if (typeof args !== 'string' && !args.formData) {
        args.body = {
          ...args.body,
          company_id: activeCompany.id,
        };
      }
      return baseQuery(args, api, extraOptions);
    }

    const urlStart = typeof args === 'string' ? args : args.url;
    const adjustedUrl = `${urlStart}${urlStart.includes('?') ? '&' : '?'}company_id=${activeCompany.id}`;
    const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };

    return baseQuery(adjustedArgs, api, extraOptions);
  };

export const baseQuery = baseQueryRaw;

export const baseQueryWithCompanyId = withCompanyId(baseQueryRaw);
export const baseQueryForAdminDashboard = baseQueryWithRetry;
